import { AppConfig } from '../types';

export const appConfig: AppConfig = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
  assetBaseUrl: process.env.REACT_APP_ASSET_BASE_URL ?? '',
  env: (process.env.REACT_APP_ENV as 'development' | 'production' | 'staging') || 'development',
};

export const API_ENDPOINTS = {
  // CMS/Global
  GLOBAL_LANDING_PAGE: '/api/globals/config/landing-page',
  GLOBAL_HEADER: '/api/globals/config/header',
  GLOBAL_FOOTER: '/api/globals/config/footer',
  GLOBAL_SOCIAL_TOOLBOX: '/api/globals/config/social-toolbox',
  GLOBAL_HEADINGS: '/api/globals/config/headings',
  GLOBAL_CONFIG: '/api/globals/config',

  // English Levels
  ENGLISH_LEVELS: '/api/english-levels',
  CLASS_DAYS: '/api/class-days',
  CLASS_DURATIONS: '/api/class-durations',

  // Analytics
  ACCESS_LOG: '/api/analysis/logs',
  ANALYTICS_DASHBOARD: '/api/analysis/dashboard',

  // Auth
  AUTH_LOGIN: '/api/auth/login',
  AUTH_REGISTER: '/api/auth/register',
  AUTH_REFRESH: '/api/auth/refresh',
  AUTH_ME: '/api/auth/me',
  AUTH_LOGOUT: '/api/auth/logout',
  AUTH_RESET_PASSWORD: '/api/auth/reset-password',

  // Consultation Requests
  CONSULTATION_REQUESTS: '/api/globals/collection/consultation-requests',
} as const;

export const CACHE_DURATION = {
  SHORT: 5 * 60 * 1000,          // 5 minutes
  MEDIUM: 30 * 60 * 1000,         // 30 minutes
  LONG: 60 * 60 * 1000,           // 1 hour
  VERY_LONG: 24 * 60 * 60 * 1000, // 24 hours
} as const;

export const STATIC_CONTENT_ITEMS = {
  HEADER: 'header',
  FOOTER: 'footer',
  ENGLISH_LEVELS: 'englishLevels',
  CLASS_DURATIONS: 'classDurations',
  CLASS_DAYS: 'classDays',
} as const;
